<template>
    <div class="sc-header">
        <button
            v-if="['messages', 'new-conversation', 'participants'].includes(currentWindow)"
            type="button"
            class="sc-header__back"
            :aria-label="currentWindow === 'participants' ? 'Back to messages' : 'Back to conversations'"
            @click="$emit('switch-window', currentWindow === 'participants' ? 'messages' : 'conversations')"
        >
            <e-icon icon="angle-left" />
        </button>
        <div class="sc-header__title">
            <template v-if="currentWindow === 'conversations'">Your Conversations</template>
            <template v-else-if="currentWindow === 'new-conversation'">New Conversation</template>
            <template v-else-if="currentWindow === 'participants'">Participants</template>
            <template v-else-if="currentWindow === 'messages'">
                <div class="is-clickable" @click="$emit('switch-window', 'participants')">
                    <header-title
                        v-if="!title.length"
                        :participants="participants"
                        :loading="participantsLoading"
                        :online="online"
                    />
                </div>
            </template>
        </div>
        <button type="button" class="sc-header__close" aria-label="Close" @click="onClose">
            <e-icon icon="times" />
        </button>
    </div>
</template>

<script>
import HeaderTitle from './HeaderTitle.vue';

export default {
    name: 'ChatHeader',

    components: { HeaderTitle },

    emits: ['switch-window'],

    props: {
        imageUrl: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        onClose: {
            type: Function,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        currentWindow: {
            type: String,
            default: 'messages',
        },
        participants: {
            type: Array,
            default: () => [],
        },
        participantsLoading: {
            type: Boolean,
            default: false,
        },
        online: {
            type: Object,
            default: () => {},
        },
        newMessagesCount: {
            type: Number,
            default: () => 0,
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.sc-header {
    background: $primary;
    color: $primary-invert;
    border-radius: $radius-large $radius-large 0 0;
    min-height: 75px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 $size-5;
}

.sc-header__title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
}

.sc-header__back {
    position: absolute;
    left: $size-5;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    color: $primary-invert;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sc-header__close {
    position: absolute;
    right: $size-5;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    color: $primary-invert;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 450px) {
    .sc-header {
        border-radius: 0;
    }
}
</style>
